// extracted by mini-css-extract-plugin
export default {"mainWrapper":"home_mainWrapper__iRd+6"};